ux-iws-sf-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 30px;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background-image: var(--ux-sf-background-image, none);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    &[variant^="center"] {
        padding: 60px calc(100% / 12);

        @media (max-width: 399px) {
            padding: 60px 15px;
        }
    }

    &[full-height] {
        min-height: 100vh;
    }

    @media (max-width: 767px) {
        ux-button {
            width: 100%;
        }
    }
}
